import { useParams } from 'react-router-dom';
import { ContextParams } from 'types/ContextParams.interface';

type CompanyContextParams = ContextParams & { companyId: string };

export const useCompanyContextParams = <Params extends Record<string, string> = {}>(): CompanyContextParams & Params => {
  const contextParams = useParams<ContextParams & Params>();
  return { ...contextParams, companyId: contextParams.contextId };
};
